import { Col, Row, Typography } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { withMergedClass } from '../../utils/reactUtils';
import { useLayoutElementsStyles } from './layoutElements.styles';

const { Title } = Typography;

export function VerticalDivider({ className }) {
  const { styles } = useLayoutElementsStyles();
  return (
    <span className={classNames(styles.verticalDivider, className)}>|</span>
  );
}

export function HorizontalDividerWithCircle({ textId, children }) {
  const { styles } = useLayoutElementsStyles();
  return (
    <div className={styles.horizontalDividerWithCircle}>
      <div className={styles.horizontalDividerWithCircleLine} />
      <div className={styles.horizontalDividerWithCircleCircle}>
        {textId ? <FormattedMessage id={textId} /> : children}
      </div>
    </div>
  );
}

export function DoubleLine({ className, ...rest }) {
  const { styles } = useLayoutElementsStyles();
  return <div className={classNames(styles.doubleLine, className)} {...rest} />;
}

export function TwoLines({ className, ...rest }) {
  const { styles } = useLayoutElementsStyles();
  return <div className={classNames(styles.twoLines, className)} {...rest} />;
}

export function ThreeLines({ className, ...rest }) {
  const { styles } = useLayoutElementsStyles();
  return <div className={classNames(styles.threeLines, className)} {...rest} />;
}

export function FlexCol({
  noOverflow,
  align = 'stretch',
  justify = 'flex-start',
  className,
  style,
  ...rest
}) {
  const { styles } = useLayoutElementsStyles();
  return (
    <div
      className={classNames(
        styles.flexCol,
        {
          [styles.flexColNoOverflow]: noOverflow,
        },
        className
      )}
      style={{
        ...style,
        alignItems: align,
        justifyContent: justify,
      }}
      {...rest}
    />
  );
}

export function Flex1({ className, ...rest }) {
  const { styles } = useLayoutElementsStyles();
  return <div className={classNames(styles.flex1, className)} {...rest} />;
}

export function TitleWithExtra({
  className,
  rightColClassName,
  title,
  titleId,
  children,
}) {
  const { styles } = useLayoutElementsStyles();
  return (
    <Row
      className={classNames(styles.titleWithExtra, className)}
      align="middle"
      justify="space-between"
    >
      <Col>
        <Title level={3}>
          {titleId ? <FormattedMessage id={titleId} /> : title}
        </Title>
      </Col>
      <Col className={rightColClassName}>{children}</Col>
    </Row>
  );
}

export const TwoLinesSeparator = withMergedClass('TwoLinesSeparator')('div');
export const DashedTwoLinesSeparator = withMergedClass(
  'DashedTwoLinesSeparator'
)('div');
